import CvPage from './cv';

export default CvPage;